import { Text } from '@chakra-ui/react';
import { IconBox, IconBoxProps } from '@core/components/Icon/Icon';
import { CMS } from '@waitroom/models';
import * as React from 'react';

export interface CmsIconProps extends Partial<IconBoxProps> {
  index?: number;
  icon: CMS.Icon | undefined;
}

const iconFontSize = {
  sm: '2xl',
  md: '3xl',
  lg: '4xl',
  xl: '5xl',
};

const CmsIcon = ({ icon, index = 0, ...rest }: CmsIconProps): React.ReactElement | null => {
  if (!icon?.icon && !icon?.isNumber) return null;
  const iconName = icon.icon?.name;
  return (
    <IconBox
      size={icon.size}
      bgColor={icon.color || 'gray.900'}
      color="white"
      rounded="full"
      fontWeight="bold"
      fontSize={iconFontSize[icon.size || 'md'] || iconFontSize.lg}
      {...rest}
    >
      {icon.isNumber ? (
        <Text fontSize="1.1em">{index + 1}</Text>
      ) : (
        <Text
          as="i"
          className={`fa-solid ${iconName?.startsWith('fa-') ? iconName : `fa-${iconName}`}`}
          fontSize="1em"
        />
      )}
    </IconBox>
  );
};
export default CmsIcon;
